<template>
	<div>
		<div style="" class="flexcenter" @click="this.compact = !this.compact">

			<b style="color:black;flex-grow:1;" class="link">Specifikation</b>
			<Icon :fileName="this.compact ? 'w3_chevron_down_dark' : 'w3_chevron_up_dark' "
				style="width:15px;height:15px;margin-right:5px;" />
		</div>

		<div :class="this.compact ? 'compact' : 'full-size' ">
			<div v-html="this.specification">
			</div>
		</div>
		<div v-if="this.compact" class="link" @click="this.compact = !this.compact"
			style="display:flex;align-items: center;margin-top:5px; background:white;color:grey;border-radius: 3px; padding-left:0px;padding-right:5px;">
			<b class="font-smaller">Visa hela specifikationen</b>
			<Icon fileName="w3_chevron_right_dark" style="width: 6px;height:10px;margin-left:5px;" />
		</div>
	</div>
</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "SpecificationHTML",
	components: {},
	mixins: [],
	props: {
		specification: String
	},
	data() {
		return {
			compact: true
		};
	},
	computed: {

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		}

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });



	},
	created() {

	}
};
</script>

<style>

div.compact{
	max-height: 200px;
	overflow-y: scroll;
}

div.full-size {
	max-height: unset;
}

table.specification {
	width: 100%;
	margin-top:10px;
	border-collapse: collapse;
		border-spacing: 0;
}

table.specification tbody tr {
	background:var(--grey-3);
}

table.specification tbody tr:nth-child(even) {
	background: var(--grey-1);
}


table.specification tbody tr td {
	
	height:30px;
}

table.specification td.col1 {
	width: 150px;
	font-weight: bold;
	color:grey;
	font-size: 0.9rem;
	padding: 5px;

}



table.specification td.col2 {
	width: auto;
	font-size: 0.8rem;
	padding: 5px;
	padding-left: 0px;
}

@media (min-width: 768px) and (max-width: 1024px) {

	table.specification,
	table.specification tbody,
	table.specification tr,
	table.specification td {
		display: block;
		width: 100%;
	}

	table.specification tr {
		margin-bottom: 0px;
	}

		table.specification tbody tr,
		table.specification tbody tr:nth-child(even) {
			background: transparent;
		}

	table.specification tbody tr td {
		height: auto;
	}

	table.specification td.col1 {
		font-weight: bold;
		background: var(--grey-3);
		width: auto;
		padding: 10px;
		
	}

	table.specification td.col2 {
		padding-bottom:10px;
		padding-left:0px;
		background: var(--grey-1);
		padding: 10px;
	}
}

@media (max-width: 500px) {
	table.specification{
		border:0px solid red;
	}

				table.specification td.col2 {
					padding-left: 0px;
				}
}
</style>